module.exports = __webpack_public_path__ + "static/img/3.4cda3c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/challenge/3.png
// module id = mSTK
// module chunks = 1